import { CollectionsService } from './../../../services/common/collections.service';
import { Component, OnInit } from '@angular/core';
import { IPersonForm } from 'src/app/models/iperson.interface';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { GeocodeService } from 'src/app/services/data/geocode.service';
import { GeoItemResource, IGeo } from 'src/app/models/igeo.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, shareReplay, startWith, switchMap } from 'rxjs/operators';
import { AutoCompleteSelectEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-person-info-form',
  templateUrl: './person-info-form.component.html',
  styleUrls: ['./person-info-form.component.css']
})
export class PersonInfoFormComponent implements OnInit {

  isAddMode: boolean;
  isFormReady = false;
  filteredGeo: IGeo[];

  frm: UntypedFormGroup;
  data: IPersonForm;

  specialities: SelectItem[] = [];

  id: number;

  lstSex: SelectItem[];
  lstScienceDegree: SelectItem[];
  lstScienceStatus: SelectItem[];
  lstSpecialities: SelectItem[];

  fltScienceDegree: SelectItem[];
  fltScienceStatus: SelectItem[];
  fltSpecialities: SelectItem[];

  searchGeo$ = new BehaviorSubject<string>('');
  filteredGeo$: Observable<GeoItemResource[]> = this.searchGeo$.pipe(
    debounceTime(500),
    distinctUntilChanged(),
    startWith(''),
    filter((val: string) => val.length > 0),
    switchMap((search: string) => this.geo.searchLocal(search)),
    shareReplay()
  );

  filteredPositions: string[] = [];
  positions: string[] = [
    'врач',
    'студент',
    'ординатор',
    'главный врач',
    'интерн',
    'зав.кафедрой',
    'зав.отделением',
    'зав.лабораторией',
    'бактериолог',
    'ассистент',
    'представитель компании',
    'клинический фармаколог',
    'заместитель главного врача',
    'директор',
    'терапевт',
    'профессор',
    'менеджер',
    'аспирант',
    'преподаватель',
    'биолог',
    'научный сотрудник',
    'старший научный сотрудник',
    'младший научный сотрудник',
    'хирург',
    'педиатр',
    'лаборант',
    'руководитель',
    'эпидемиолог',
    'провизор',
    'анестезиолог-реаниматолог'
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private coll: CollectionsService,
    private geo: GeocodeService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) { }

  ngOnInit() {
    this.isAddMode = this.config.data.isAdd;
    this.data = this.config.data.item;

    this.lstSex = this.coll.SEX.slice();
    this.lstScienceDegree = this.coll.SCIENCE_DEGREES.slice();
    this.lstScienceStatus = this.coll.SCIENCE_STATUSES.slice();
    this.lstSpecialities = this.coll.SPECIALITIES.slice();

    if (!this.isAddMode) {
      this.data.specialities.forEach(spec => {
        const item = this.lstSpecialities.find(o => o.value === spec);
        if (item) this.specialities.push(item);
      });

    }

    this.initForm();
  }

  initForm() {

    this.frm = this.fb.group({
      firstName: new UntypedFormControl('', { validators: Validators.required, updateOn: 'blur' }),
      secondName: new UntypedFormControl('', { validators: Validators.required, updateOn: 'blur' }),
      thirdName: new UntypedFormControl(''),
      dateBirth: new UntypedFormControl(''),
      sex: new UntypedFormControl(''),
      phones: new UntypedFormControl([]),
      emails: new UntypedFormControl([]),
      workplace: new UntypedFormControl(''),
      position: new UntypedFormControl(''),
      cityName: new UntypedFormControl(''),
      scienceDegreeId: new UntypedFormControl(0),
      scienceStatusId: new UntypedFormControl(0),
      specialities: new UntypedFormControl([...this.specialities]),
      city: new UntypedFormControl(''),
      region: new UntypedFormControl(''),
      country: new UntypedFormControl(''),
      info: new UntypedFormControl('')
    });

    if (!this.isAddMode) {
      this.frm.patchValue(this.data);
      this.frm.patchValue({ specialities: [...this.specialities] }, { emitEvent: false });
    } else if (this.data) {
      this.frm.patchValue({ firstName: this.data.firstName, secondName: this.data.secondName, thirdName: this.data.thirdName}, {emitEvent: false});
    }

    this.isFormReady = true;
  }

  filterScienceDegree(event) {
    let query = event.query;
    this.fltScienceDegree = [];
    for (let i = 0; i < this.lstScienceDegree.length; i++) {
      let country = this.lstScienceDegree[i];
      if (country.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        this.fltScienceDegree.push(country);
      }
    }
  }

  searchGeo(event: any) {
    const query = event.query;
    this.geo.search(query).subscribe(
      data => this.filteredGeo = data
    );
  }

  onSelectGeoItem(event: AutoCompleteSelectEvent) {
    // Assuming the selected item is available in the 'value' property of the event
    const selectedGeoItem: GeoItemResource = event.value;

    this.frm.patchValue({
      city: selectedGeoItem.cityName,
      region: selectedGeoItem.regionName,
      country: selectedGeoItem.countryName
    }, { emitEvent: false });
  }

  filterScienceStatus(event) {
    let query = event.query;
    this.fltScienceStatus = [];
    for (let i = 0; i < this.lstScienceStatus.length; i++) {
      let item = this.lstScienceStatus[i];
      if (item.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        this.fltScienceStatus.push(item);
      }
    }
  }

  filterSpeciality(event) {
    let query = event.query;
    this.fltSpecialities = [];
    for (let i = 0; i < this.lstSpecialities.length; i++) {
      let item = this.lstSpecialities[i];
      if (item.label.toLowerCase().indexOf(query.toLowerCase()) != -1) {
        this.fltSpecialities.push(item);
      }
    }
  }

  onCancel() {
    this.ref.close();
  }

  onSubmit(f: UntypedFormGroup) {
    f.markAllAsTouched();
    if (!f.valid) return;

    this.data = {
      firstName: f.value['firstName'] || '',
      secondName: f.value['secondName'] || '',
      thirdName: f.value['thirdName'] || '',

      dateBirth: f.value['dateBirth'] || '',
      sex: f.value['sex'] || '',
      phones: f.value['phones'] || [],
      emails: f.value['emails'] || [],

      workplace: f.value['workplace'] || '',
      position: f.value['position'] || '',

      scienceDegreeId: f.value['scienceDegreeId'] || 0,
      scienceStatusId: f.value['scienceStatusId'] || 0,
      specialities: f.value['specialities'].map((o: SelectItem) => o.value),

      city: f.value['city'] || '',
      region: f.value['region'] || '',
      country: f.value['country'] || '',
      info: f.value['info'] || ''
    } as IPersonForm;

    this.ref.close(this.data);
  }

  filterPosition(event) {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.positions.length; i++) {
      let position = this.positions[i];
      if (position.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(position);
      }
    }

    this.filteredPositions = filtered;
  }

}
